import { render } from "./compare.vue?vue&type=template&id=975e681e&scoped=true&ts=true"
import script from "./compare.vue?vue&type=script&lang=ts"
export * from "./compare.vue?vue&type=script&lang=ts"

import "./compare.vue?vue&type=style&index=0&id=975e681e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975e681e"]])

export default __exports__